module.exports = __webpack_public_path__ + "img/81w.aa84c33.jpg";